/**
 * Magna Image with Accordion
 * Single-open accordion behavior — clicking one item closes the others.
 */
(function () {
  'use strict';

  const section = document.querySelector('[data-magna-image-accordion]');
  if (!section) return;

  const items = section.querySelectorAll('[data-mia-item]');

  items.forEach((item) => {
    const trigger = item.querySelector('.magna-image-accordion__trigger');
    const panel = item.querySelector('.magna-image-accordion__panel');
    if (!trigger || !panel) return;

    // Set initial state for open items
    if (item.classList.contains('is-open')) {
      panel.style.maxHeight = panel.scrollHeight + 'px';
    }

    trigger.addEventListener('click', () => {
      const isOpen = item.classList.contains('is-open');

      // Close all items
      items.forEach((other) => {
        const otherPanel = other.querySelector('.magna-image-accordion__panel');
        if (other !== item && other.classList.contains('is-open')) {
          otherPanel.style.maxHeight = otherPanel.scrollHeight + 'px';
          requestAnimationFrame(() => {
            otherPanel.style.maxHeight = '0px';
          });
          other.classList.remove('is-open');
          other.querySelector('.magna-image-accordion__trigger')
            ?.setAttribute('aria-expanded', 'false');
        }
      });

      // Toggle clicked item
      if (isOpen) {
        panel.style.maxHeight = panel.scrollHeight + 'px';
        requestAnimationFrame(() => {
          panel.style.maxHeight = '0px';
        });
        item.classList.remove('is-open');
        trigger.setAttribute('aria-expanded', 'false');
      } else {
        item.classList.add('is-open');
        panel.style.maxHeight = panel.scrollHeight + 'px';
        trigger.setAttribute('aria-expanded', 'true');

        panel.addEventListener('transitionend', function handler() {
          if (item.classList.contains('is-open')) {
            panel.style.maxHeight = 'none';
          }
          panel.removeEventListener('transitionend', handler);
        });
      }
    });
  });
})();
